import { useMutation } from '@tanstack/react-query';
import { useToast } from '@chakra-ui/react';
import { addCustomNotification } from 'api/auth.api';

export const useAddCustomNotification = ({ onSuccess } = {}) => {
  const toast = useToast();

  return useMutation({
    mutationFn: addCustomNotification,

    onSuccess: (res) => {
      toast({
        title: 'Custom notification created',
        description: res?.data?.message || 'Created successfully',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });

      onSuccess?.(res);
    },

    onError: (error) => {
      toast({
        title: 'Failed to create',
        description: error?.response?.data?.message || 'Something went wrong',
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
